import LiveAssetModel from '../../models/media/liveAssetModel';
import {Collection} from 'backbone';
const LiveAssetCollection = Collection.extend({
    url: '/api/rest/facade/video/assetsByChannel/',
    model: LiveAssetModel,
    parse(data) {
        if (data) {
            try {
                this.add(data.hasOwnProperty('data') ? data.data[0].assets : data[0].assets);
            } catch (e) {
                console.error('LiveAssetCollection parse failure', e);
            }
        }

        return this.models;
    },
});
export default LiveAssetCollection;
